// extracted by mini-css-extract-plugin
module.exports = {"bordered-list":"Dropdown_bordered-list__8io1_","base_dropdown":"Dropdown_base_dropdown__3i33H"};